import React from 'react'
import Back from './../Public/Image/Home/Back.svg'
import './GetLinkUsername.css'
import TextField from '@mui/material/TextField';
import ViewCheckUsername from '../BottomSheet/ViewCheckUsername';
import ShowPriceAndChannel from '../BottomSheet/ShowPriceAndChannel';
import { useState } from 'react';
import { setBottomSheetViewCheckUsername } from './../app/Home'
import { setUserNameForOrder } from './../app/Home'
import { GetCookie } from '../Action/GetCookie';
// import { CheckChannelBeforePurchase } from './../Api/CheckChannelBeforePurchase'
// import { AllApi } from './../Api/AllApi'
import { BottomSheet } from 'react-spring-bottom-sheet'

import { useSelector, useDispatch } from 'react-redux'
import TooManyOrders from './../BottomSheet/TooManyOrders'
import ViolatingChannel from './../BottomSheet/ViolatingChannel'
import { setBottomSheetTooManyOrders } from './../app/Home'
import { setBottomSheetViolatingChannel } from './../app/Home'
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ViewShowPriceAndChannel from './../BottomSheet/ViewShowPriceAndChannel'
import { setBottomSheetViewShowPriceAndChannel } from './../app/Home'
import { setPostLink } from './../app/Home'
import { AllApi } from './../Api/AllApi'
import View from './../Public/Image/wheel/view.png'
import { useHistory } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import { SetCookie } from './../Action/SetCookie'


const GetUsernameView = () => {
    const Token = GetCookie('Token')
    const location = useLocation();
    const history = useHistory();

    const searchParams = new URLSearchParams(location.search);
    const price = searchParams.get('price');
    const count = searchParams.get('count');
    const ByCoin = searchParams.get('ByCoin');
    const PostViewFilter = searchParams.get('PostViewFilter');

    const PostLink = useSelector((state) => state.Home.PostLink)
    const [LastUsername, setLastUsername] = useState('')
    const [Username, setUsername] = useState('')
    const [UsernameError, setUsernameError] = useState(false)
    const [UsernameErrorEmpty, setUsernameErrorEmpty] = useState(false)
    const dispatch = useDispatch()
    const UserNameForOrder = useSelector((state) => state.Home.UserNameForOrder)
    const [MemberReward, setMemberReward] = useState(false)
    const [MemberRewardCount, setMemberRewardCount] = useState('')
    function onDismiss() {
        setTimeout(() => {
            MemberReward(false)
        }, 300);
    }
    const [Snackopen, setSnackOpen] = useState(false)


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackOpen(false);
    };
    const [BottomSheetCheckUsernameGift, setBottomSheetCheckUsernameGift] = useState(false)
    const SaveSpinView = async (LastUsername) => {
        try {
            setBottomSheetCheckUsernameGift(false)

            const api = new AllApi();

            const giftRaw = localStorage.getItem("GiftUser");
            if (!giftRaw) {
                setSnackOpen(true);
                history.push('/Home?Status=Member')

                console.warn("No GiftUser found in localStorage.");
                return;
            }

            const gift = JSON.parse(giftRaw);

            const messageIds = PostViewFilter === "1" ? [Number(PostLink)] : [];
            // console.log("LastUsername:", LastUsername, "MessageIds:", messageIds);

            const res = await api.SaveSpin(gift.token, Token, LastUsername, messageIds);
            // console.log(res)
            if (!res) {
                console.error("SaveSpin returned no response.");
                setSnackOpen(true);

                return;
            }

            switch (res.code) {
                case 301:
                    // console.log("You have already claimed the reward!");
                    setSnackOpen(true);
                    history.push('/Home?Status=Member')
                    break;

                case 200:
                    if (res?.data?.data?.claimReward) {
                        console.error("Reward already claimed!");
                        setSnackOpen(true); // نمایش خطا
                        history.push("/Home?Status=Member");
                        return;
                    }
                    setMemberRewardCount(gift.gift);
                    setMemberReward(true);
                    // پاک‌سازی داده‌ها
                    SetCookie("Gifttoken", null, -100);
                    // SetCookie("GiftTime", null, -100);

                    localStorage.removeItem("GiftUser");
                    break;

                default:
                    console.warn("Unexpected API response:", res);
            }
        } catch (error) {
            console.error("Error in SaveSpin flow:", error);
        }
    }
    const HandleUsernameLink = async () => {


        if (LastUsername.length == 0) {
            setUsernameErrorEmpty(true)
        } else {
            if (UsernameError == false && UsernameErrorEmpty == false) {
                if (LastUsername.length < 4 && LastUsername.length >= 0) {
                    setUsernameError(true)
                } else {

                    if (price == '0') {
                        dispatch(setUserNameForOrder(LastUsername))

                        setBottomSheetCheckUsernameGift(true)

                    } else {
                        if (PostViewFilter === '1') {
                            // OnePost

                            dispatch(setUserNameForOrder(LastUsername))
                            dispatch(setBottomSheetViewShowPriceAndChannel(true))
                        } else {
                            // Multi Post
                            dispatch(setBottomSheetViewCheckUsername(true))
                            dispatch(setUserNameForOrder(LastUsername))
                        }
                    }



                }
            }
        }
    }
    const HandleChange = (value) => {
        // OnePost
        let result = value.trim();
        result = result.toLowerCase();
        setUsername(result)

        setUsernameErrorEmpty(false)
        setUsernameError(false)
        setLastUsername(result)
        const resultid = extractUsernameAndPostId(value);

        if (resultid == 'Invalid URL length. Please provide a valid Telegram URL.') {
            if (value.length > 4) {

                setUsernameError(true)
            }
        } else {
            if (result.length > 0) {

                if (resultid) {
                    let responseV = isValidTelegramUsername(resultid.username)

                    if (responseV == true) {
                        setLastUsername(resultid.username)
                        dispatch(setPostLink(resultid.postId))
                        setUsernameError(false)
                    } else {
                        setUsernameError(true)

                    }

                } else {
                    setUsernameError(true)

                }
            } else {
                setUsernameError(false)
            }
        }

    }

    // const telegramUsernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{3,31}$/;
    const telegramUsernameRegex = /^[a-zA-Z][a-zA-Z0-9_]{3,30}[a-zA-Z0-9]$/;

    function isValidTelegramUsername(username) {
        return telegramUsernameRegex.test(username);
    }

    function extractUsernameAndPostId(url) {
        const regex = /https:\/\/t.me\/([^\/]+)\/(\d+)/;
        const match = url.match(regex);
        let Error;
        if (match && match.length === 3) {
            const username = match[1];
            const postId = match[2];

            // Check if the entire URL matches the expected format
            if (url.length === match[0].length) {
                return { username, postId };
            } else {
                Error = 'Invalid URL length. Please provide a valid Telegram URL.'
                // throw new Error('Invalid URL length. Please provide a valid Telegram URL.');
            }
        } else {
            Error = 'Invalid URL length. Please provide a valid Telegram URL.'

        }
        return Error
    }

    const HandleChangeUsername = (value) => {

        let result = value.trim();
        setUsername(result)
        setUsernameErrorEmpty(false)
        setUsernameError(false)

        let PositionLink = value.search("https://t.me/");//11 length
        let PositionSign = value.search("@");
        const startsWithAlphabetRegex = /^[A-Za-z]/;
        let username
        if (PositionLink == 0) {
            // let LinkHttps = result.slice(0, 13);
            username = result.replace('https://t.me/', '');

        } else if (PositionSign == 0) {
            // let LinkSign = result.slice(0, 1);
            username = result.replace('@', '');

        } else {
            username = result
        }
        // let SatrtWitheAlphabet = startsWithAlphabetRegex.test(username);
        setLastUsername(username)

        if (username.length > 4) {
            if (isValidTelegramUsername(username)) {
                setUsernameError(false)

            } else {
                setUsernameError(true)
            }
        }

    }



    return (
        <div className='GetLinkUsername'>
            <div className='GetLinkUsernameHeader'>
                <Link to="/Home?Status=View" className="GetLinkUsernameHeaderLink">  <img src={Back} className='GetLinkUsernameHeaderImg' />
                </Link>
                <div className='GetLinkUsernameHeaderText'>
                    {
                        PostViewFilter == '1' ? 'Post link' : 'Channel/Group Link'
                    }
                </div>
            </div>
            <div className='GetLinkUsernameContent'>
                <div className='GetLinkUsernameContentText1'>
                    {
                        PostViewFilter == '1' ? 'Please enter the link to the desired post' : 'Please enter your Telegram channel/group link'
                    }
                </div>
                <div className='GetLinkUsernameInputContainer'>
                    {

                        UsernameErrorEmpty ?
                            <TextField
                                error
                                id="outlined-error"
                                label={PostViewFilter == '1' ? "Post link" : "Link"}
                                defaultValue="Hello World"
                                className='GetLinkUsernameInput'
                                onChange={(e) => PostViewFilter == '1' ? HandleChange(e.target.value) : HandleChangeUsername(e.target.value)}
                                value={Username}
                                helperText="field is empty"
                            />
                            :
                            UsernameError ?
                                <TextField
                                    error
                                    id="outlined-error"
                                    label={PostViewFilter == '1' ? "Post link" : "Link"}
                                    defaultValue="Hello World"
                                    className='GetLinkUsernameInput'
                                    onChange={(e) => PostViewFilter == '1' ? HandleChange(e.target.value) : HandleChangeUsername(e.target.value)}
                                    value={Username}
                                    helperText="format is incorrect"
                                />
                                : <TextField id="outlined-basic"
                                    label={PostViewFilter == '1' ? "Post link" : "Link"}
                                    variant="outlined"
                                    className='GetLinkUsernameInput'
                                    onChange={(e) => PostViewFilter == '1' ? HandleChange(e.target.value) : HandleChangeUsername(e.target.value)}
                                    value={Username}
                                />
                    }


                </div>
                <div className='GetLinkUsernameContentText'>
                    {PostViewFilter == '1' ? `Tab the desired post and choose "Copy Post Link" option and then paste it here` : 'Please ensure the following before placing an order:'}
                </div>
                <ul className='GetLinkUsernameContentTextUl'>
                    {PostViewFilter == '1' ?
                        null
                        : <li>
                            The channel must be public
                        </li>}
                </ul>
            </div>
            <div className='GetLinkUsernameFooter'>
                <button className='GetLinkUsernameFooterButton' onClick={() => HandleUsernameLink()}>
                    Next
                </button>
            </div>
            {
                ByCoin ? <ViewShowPriceAndChannel /> : <ViewShowPriceAndChannel />
            }
            <ViewCheckUsername />

            <TooManyOrders />
            <ViolatingChannel />

            <BottomSheet onDismiss={onDismiss}
                open={MemberReward}
            >
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className={`RegisterBeforeBottomSheetHeaderText `}>
                            <div >
                                🎉 Reward Claimed  🎉
                            </div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBody' style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                        {MemberRewardCount} <img width={16} height={14} src={View} style={{ margin: "0 4px 0 4px" }} />   have been registered for the single post at {UserNameForOrder}
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        {/* <button className='BottomSheetCancelButton' onClick={() => setCoinReward(false)}>got it</button> */}
                        <button className='BottomSheetLoginButton' style={{ width: "100%" }} onClick={() => { setMemberReward(false); history.push('/Home?Status=Member') }}>Got it</button>
                    </div>
                </div>
            </BottomSheet>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={Snackopen}
                autoHideDuration={4000}
                onClose={handleClose}
                message=" Something went wrong!"
            // action={action}
            />
            <BottomSheet onDismiss={onDismiss} open={BottomSheetCheckUsernameGift}>
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className={`RegisterBeforeBottomSheetHeaderText ${UserNameForOrder.length > 24 ? 'scrolling-text-container' : null} `}>
                            <div className={`${UserNameForOrder.length > 24 ? "scrolling-text" : null}`}>@{UserNameForOrder}</div>
                        </div>
                    </div>
                    <div className='RegisterBeforeBottomSheetBody'>
                        Are you sure
                        <span className='UserNameChannelBold ' >
                            @{UserNameForOrder}
                        </span>

                        is the username you are looking for?
                    </div>
                    <div className='RegisterBeforeBottomSheetFooter'>
                        <button className='BottomSheetCancelButton' onClick={() => setBottomSheetCheckUsernameGift(false)}>Cancel</button>
                        <button className='BottomSheetLoginButton' onClick={() => SaveSpinView(UserNameForOrder)}>Yes, next</button>
                    </div>
                </div>
            </BottomSheet>
        </div>
    )
}

export default GetUsernameView